import React, { useState } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  SxProps,
  useTheme,
  Typography,
} from '@mui/material';

interface SelectInputProps {
  id?: string;
  label: string;
  name: string;
  items: { value: string; text: string }[];
  onChange: (e: SelectChangeEvent) => void;
  sx?: SxProps;
  fullWidth?: boolean;
  required?: boolean;
  disabled?: boolean;
  displayEmpty?: boolean;
  defaultValue?: any;
  size?: 'small' | 'medium' | undefined;
  value?: string;
  tabIndex?: number;
}
export function SelectInput({
  id,
  label,
  name,
  onChange,
  items,
  sx,
  fullWidth,
  required,
  disabled,
  defaultValue,
  size = 'medium',
  value,
  displayEmpty,
  tabIndex,
}: SelectInputProps) {
  const theme = useTheme();
  const [selectValue, setSelectValue] = useState(defaultValue || '');
  const handleChange = (event: SelectChangeEvent) => {
    setSelectValue(event.target.value);
    onChange(event);
  };

  return (
    <FormControl fullWidth={fullWidth}>
      <InputLabel id={`select-${label}`}>
        <Typography color={theme.palette.text.disabled}>{label}</Typography>
      </InputLabel>
      <Select
        size={size}
        data-testid={name}
        id={id}
        value={selectValue}
        label={label}
        onChange={handleChange}
        sx={sx}
        required={required}
        name={name}
        disabled={disabled}
        displayEmpty={displayEmpty}
        defaultValue={selectValue}
        tabIndex={tabIndex}
      >
        {items.map((item) => {
          return (
            // TODO in some cases we use text as value and some cases we use actual value which is different than text - TBD
            <MenuItem
              key={item.value}
              value={item.value}
              data-testid="incidentSelectDropdown"
            >
              {item.text}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
